/// <reference path="../../typings/browser.d.ts" />

namespace Application.Services {
    'use strict';

    import IUser = Models.IUser;
    import HalConverter = Models.HalConverter;

    export class UserService {
        public static $name: string = "userService";
        public static $inject: string[] = ['$q', 'backendService'];

        private backendBaseUrl: string = window.backendUrl;
        private servicePath: string = 'flexauth/';
        private currentUserUrl: string = this.backendBaseUrl + 'currentUser';
        private usersUrl: string = this.backendBaseUrl + this.servicePath + 'users/';
        private updateUsersUrl: string = this.backendBaseUrl + 'vnos/users/';
        private impersonateUserUrl: string = this.backendBaseUrl + 'impersonate?username=';
        private endImpersonateUserUrl: string = this.backendBaseUrl + 'endimpersonate';

        private pendingPromise: Promise<Models.User> | any;

        private currentUser: Models.User;

        constructor(private $q: ng.IQService,
                    private backendService: Services.BackendService) {
            if (this.currentUser === undefined) {
                this.loadCurrentUser().then((user: Models.User) => {
                    this.currentUser = user;
                });
            }
        }

        public getCurrentUser(): Models.User {
            return this.currentUser;
        }

        public loadCurrentUser(forceRefresh: boolean = false): Promise<Models.User> | any{
            if (this.currentUser && !forceRefresh) {
                return new Promise<Models.User>((resolve: Function, reject: Function) => {
                    resolve(this.currentUser);
                });
            } else {
                if(this.pendingPromise) return this.pendingPromise;
                return this.pendingPromise = this.backendService.get(this.currentUserUrl)
                .then((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<Models.User>>) => {
                    this.currentUser = HalConverter.convertElement(result.data, Models.User.createEmpty);
                    return this.currentUser;
                });    
            }
        }

        public unloadCurrentUser(): void {
            this.currentUser = undefined;
        }

        public findAll(): ng.IPromise<IUser[]> {
            return this.backendService
                .get(this.usersUrl)
                .then((response: ng.IHttpPromiseCallbackArg<IUser[]>)  => {
                    return this.filterOutDemiurge(response.data);
                });
        }

        public findAllIncludingDisabled(): ng.IPromise<IUser[]> {
            return this.backendService
                .get(this.usersUrl + "?includeDisabled=true")
                .then((response: ng.IHttpPromiseCallbackArg<IUser[]>)  => {
                    return this.filterOutDemiurge(response.data);
                });
        }

        public findById(id: number): ng.IPromise<IUser> {
            return this.backendService
                .get(this.usersUrl + id)
                .then((response: ng.IHttpPromiseCallbackArg<IUser>)  => {
                    return response.data;
                });
        }

        public findByUsername(username: string): ng.IPromise<IUser> {
            return this.backendService
                .get(this.usersUrl + 'search/findByUsername?username=' + username)
                .then((response: ng.IHttpPromiseCallbackArg<IUser>)  => {
                    return response.data;
                });
        }

        public findByEmail(email: string): ng.IPromise<IUser> {
            return this.backendService
                .get(this.usersUrl + 'search/findByEmail?email=' + email)
                .then((response: ng.IHttpPromiseCallbackArg<IUser>)  => {
                    return response.data;
                });
        }

        // public findByUsernameOrEmail(usernameOrEmail: string): ng.IPromise<IUser> {
        //     return this.backendService
        //         .get(this.usersUrl + 'search/findByUsernameOrEmail?username=' + usernameOrEmail)
        //         .then((response: ng.IHttpPromiseCallbackArg<IUser>)  => {
        //             return response.data;
        //         });
        // }

        // public getUserRoles(userId: number): ng.IPromise<string[]> {
        //     return this.backendService
        //         .get(this.usersUrl + userId + '/roles')
        //         .then((response: ng.IHttpPromiseCallbackArg<string[]>)  => {
        //             return response.data;
        //         });
        // }

        
        // public getUserRoles(userId: number): ng.IPromise<string[]> {
        //     return this.backendService
        //         .get(`${this.backendBaseUrl}users/${userId}/roles`)
        //         .then((response: ng.IHttpPromiseCallbackArg<string[]>)  => {
        //             return response.data;
        //         });
        // }

        public saveUser(user: IUser): ng.IPromise<IUser> {
            if (!user.id || user.id === undefined || user.id === '') {
                return this.createUser(user);
            } else {
                return this.updateUser(user);
            }
        }

        public createUser(user: IUser): ng.IPromise<IUser> {
            return this.backendService
                .post(this.usersUrl, {
                    username: user.username,
                    fullname: user.fullname,
                    password: user.password,
                    email: user.email,
                    enabled: user.enabled,
                    created: user.created,
                })
                .then((result: ng.IHttpPromiseCallbackArg<IUser>) => {
                    return result.data;
                 });
        }

        public updateUser(user: IUser): ng.IPromise<IUser> {
            return this.backendService
                .put(this.updateUsersUrl + user.id, {
                    username: user.username,
                    fullname: user.fullname,
                    password: user.password,
                    email: user.email,
                    avatar: user.avatar,
                    enabled: user.enabled,
                    created: user.created,
                })
                .then((result: ng.IHttpPromiseCallbackArg<IUser>) => {
                    if (user.enabled === true) {
                        this.refreshUser(user.id);
                    }
                    return result.data;
                });
        }

        public impersonateUser(userName: string): ng.IPromise<any> {
            return this.backendService
                .get(this.impersonateUserUrl + userName)
                .then((result: any) => {
                    window.location.href = '/';
                });
        }

        public endImpersonateUser(): ng.IPromise<any> {
            return this.backendService
                .get(this.endImpersonateUserUrl)
                .then((result: any) => {
                    window.location.href = '/';
                });
        }

        public updatePassword(oldPassword: string, newPassword: string): ng.IPromise<boolean> {
            return this.backendService
                .put(this.backendBaseUrl+ "password", {
                    oldPassword: oldPassword,
                    newPassword: newPassword,
                })
                .then((result: ng.IHttpPromiseCallbackArg<boolean>) => {
                    return result.data;
                });
        }

        public addRoleToUser(user: IUser, rolename: string): ng.IPromise<IUser> {
            return this.backendService
                .put(this.usersUrl + user.id + "/roles/" + rolename, {})
                .then((result: ng.IHttpPromiseCallbackArg<IUser>) => {
                    this.refreshUser(user.id);
                    return result.data;
            });
         }

        public deleteRoleFromUser(user: IUser, rolename: string): ng.IPromise<void> {
            return this.backendService
                .delete(this.usersUrl + user.id + "/roles/" + rolename)
                .then(() => {
                    this.refreshUser(user.id);
                    return;
                });
        }

        public userHasRolePromise(role: string): Promise<boolean> {
            return this.loadCurrentUser().then(() => {
                return this.userHasRole(role)
            });
        }

        public userHasRole(role: string): boolean {
            return this.currentUser && this.currentUser.authorities.some(
                auth => auth.authority.indexOf(role) > -1
            );
        }

        public refreshUser(userId: number | string): ng.IPromise<{}> {
            return this.backendService.post(this.backendBaseUrl + 'refreshUser', Number(userId));
        }

        public refreshUsers(usersIds: number[]): ng.IPromise<{}> {
            return this.backendService.post(this.backendBaseUrl + 'refreshUsers', usersIds);
        }

        public destroySessionByUserId(userId: number | string): ng.IPromise<{}> {
            return this.backendService.post(this.backendBaseUrl + 'destroySessionByUserId', Number(userId));
        }

        private filterOutDemiurge(users: Models.IUser[]): Models.IUser[] {
            return users.filter((user: Models.IUser) => {
                return user.username !== 'demiurgo';
            });
        }

        public userIsRegularVnoUser() {
            return this.userHasRole('ORG_USER')
            && !this.userHasRole('ORG_ADMIN')
            && !this.userHasRole('ROLE_ADMIN');
        }
    }
}
